import {
  AFTER_SALES_VOLUME_RANGE,
  AfterSalesVolumeRange,
  BUSINESS_ACTIVITY,
  BUSINESS_DOMAIN,
  BusinessActivity,
  BusinessDomain,
  CUSTOMER_KIND,
  CustomerKind,
} from '@savgroup-front-common/types/CompanyDirectory';

import {
  OnboardingActivityTypes,
  OnboardingCustomerVertical,
} from '../OnboardingActivities.constant';

export const ACTIVITY_TO_CUSTOMER_VERTICAL: Record<
  BusinessActivity,
  string | undefined
> = {
  [BUSINESS_ACTIVITY.UNKNOWN]: undefined,
  [BUSINESS_ACTIVITY.RETAILER]: OnboardingCustomerVertical.RETAILER,
  [BUSINESS_ACTIVITY.E_COMMERCE]: OnboardingCustomerVertical.E_COMMERCE,
  [BUSINESS_ACTIVITY.REPAIRER]: OnboardingCustomerVertical.REPAIRER,
  [BUSINESS_ACTIVITY.MANUFACTURER]: OnboardingCustomerVertical.MANUFACTURER,
  [BUSINESS_ACTIVITY.INDUSTRIAL]: OnboardingCustomerVertical.INDUSTRIAL,
  [BUSINESS_ACTIVITY.WHOLESALER]: OnboardingCustomerVertical.WHOLESALER,
};

export const DOMAIN_TO_ACTIVITY_TYPE: Record<
  BusinessDomain,
  string | undefined
> = {
  [BUSINESS_DOMAIN.UNKNOWN]: undefined,
  [BUSINESS_DOMAIN.HIGH_TECH]: OnboardingActivityTypes.HIGH_TECH,
  [BUSINESS_DOMAIN.HOME_APPLIANCES]: OnboardingActivityTypes.HOME_APPLIANCES,
  [BUSINESS_DOMAIN.DO_IT_YOURSELF]: OnboardingActivityTypes.HANDIWORK,
  [BUSINESS_DOMAIN.SPORT]: OnboardingActivityTypes.SPORT,
  [BUSINESS_DOMAIN.MOBILITY]: OnboardingActivityTypes.MOBILITY,
  [BUSINESS_DOMAIN.FURNITURE]: OnboardingActivityTypes.FURNISHING,
  [BUSINESS_DOMAIN.BEAUTY]: OnboardingActivityTypes.BEAUTY,
  [BUSINESS_DOMAIN.FASHION]: OnboardingActivityTypes.MODE,
  [BUSINESS_DOMAIN.JEWELLERY]: OnboardingActivityTypes.JEWELRY,
  [BUSINESS_DOMAIN.CHILDCARE]: OnboardingActivityTypes.CHILDCARE,
  [BUSINESS_DOMAIN.TOYS_AND_CRAFTS]: OnboardingActivityTypes.GAMES,
  [BUSINESS_DOMAIN.OTHER]: OnboardingActivityTypes.OTHER,
};

export const VOLUME_TO_ACTIVITY_TYPE: Record<
  AfterSalesVolumeRange,
  string | undefined
> = {
  [AFTER_SALES_VOLUME_RANGE.UNKNOWN]: undefined,
  [AFTER_SALES_VOLUME_RANGE.UP_TO_1000]:
    OnboardingActivityTypes.MIN_RETURN_VOLUME,
  [AFTER_SALES_VOLUME_RANGE.FROM_1000_TO_5000]:
    OnboardingActivityTypes.LITTLE_RETURN_VOLUME,
  [AFTER_SALES_VOLUME_RANGE.FROM_5000_TO_10000]:
    OnboardingActivityTypes.MEDIUM_RETURN_VOLUME,
  [AFTER_SALES_VOLUME_RANGE.FROM_10000_TO_100000]:
    OnboardingActivityTypes.HIGH_RETURN_VOLUME,
  [AFTER_SALES_VOLUME_RANGE.ABOVE_100000]:
    OnboardingActivityTypes.MAX_RETURN_VOLUME,
};

export const CUSTOMERS_TO_ACTIVITY_TYPE: Record<
  CustomerKind,
  string | undefined
> = {
  [CUSTOMER_KIND.UNKNOWN]: undefined,
  [CUSTOMER_KIND.BUSINESS]: OnboardingActivityTypes.ENTERPRISE,
  [CUSTOMER_KIND.CONSUMER]: OnboardingActivityTypes.PRIVATE,
  [CUSTOMER_KIND.BOTH]: OnboardingActivityTypes.BOTH_CUSTOMER,
};
